import { MapPin, Phone, User } from "lucide-react";
import AddressDropdown from "../inputs/AddressDropdown";
import CitySelectorForm from "../inputs/CitySelectorForm";

interface DestinationSectionProps {
  formData: any;
  setFormData: (data: any) => void;
  handleDestinationLocationChange: (location: any) => void;
  handleCityChange: (city: any) => void;
}

const DestinationSection: React.FC<DestinationSectionProps> = ({
  formData,
  setFormData,
  handleDestinationLocationChange,
  handleCityChange
}) => {
  // DEBUG - poți adăuga temporar pentru a vedea ce valori primești
  console.log("DestinationSection formData:", formData);
  
  return (
    <div className="bg-gradient-to-r from-purple-50 to-violet-50 rounded-xl p-4 border border-purple-200 shadow-sm">
      <div className="flex items-center mb-4">
        <div className="p-2 bg-purple-500 rounded-lg mr-3">
          <MapPin className="w-4 h-4 text-white" />
        </div>
        <h3 className="font-semibold text-gray-800 text-lg">Destinație Principală</h3>
      </div>

      <div className="space-y-4">
        {/* Location Fields */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Oraș destinație *
            </label>
            <CitySelectorForm
              selectedCity={formData.oras_destinatie || ""}
              onCityChange={handleCityChange}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Adresa destinație *
            </label>
            <AddressDropdown
              value={formData.locatie_destinatie_id ? {
                id: formData.locatie_destinatie_id,
                adresa: formData.destinatie || '',
                oras: formData.oras_destinatie,
                tara: 'Romania',
                tip: 'destinatie'
              } : null}
              onChange={handleDestinationLocationChange}
              city={formData.oras_destinatie || ''}
              type="destinatie"
              placeholder="Caută sau adaugă adresa de destinație"
              required
            />
          </div>
        </div>

        {/* Contact Information */}
        <div className="bg-white rounded-lg p-4 border border-purple-100">
          <div className="flex items-center mb-3">
            <div className="p-1.5 bg-purple-100 rounded-lg mr-2">
              <User className="w-4 h-4 text-purple-600" />
            </div>
            <h4 className="font-medium text-gray-800">Contact Destinație</h4>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                <User className="w-4 h-4 inline mr-1" />
                Nume destinatar
              </label>
              <input
                type="text"
                value={formData.nume_destinatar || ""}
                onChange={(e) =>
                  setFormData(prev => ({ ...prev, nume_destinatar: e.target.value }))
                }
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-colors"
                placeholder="Numele persoanei de contact"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                <Phone className="w-4 h-4 inline mr-1" />
                Telefon destinatar *
              </label>
              <input
                type="tel"
                value={formData.telefon_destinatar || ""}
                onChange={(e) =>
                  setFormData(prev => ({ ...prev, telefon_destinatar: e.target.value }))
                }
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-colors"
                placeholder="Ex: +40721654321"
                required
              />
            </div>
          </div>

          <p className="text-xs text-gray-500 mt-2">
            Contactul persoanei care va primi paletul/paletii la această destinație
          </p>
        </div>
      </div>
    </div>
  );
};

export default DestinationSection;